import { ResultOf } from '@graphql-typed-document-node/core'

import { useGoTo } from '@web/hooks/useGoTo'
import { Nullish } from '@web/types'
import Footer from '@web/ui/components/Footer'

import { FooterSectionUser } from './fragment'

type Props = {
  user: Nullish<ResultOf<typeof FooterSectionUser>>
}

const FooterSection = ({ user }: Props) => {
  const isLogin = !!user
  const { goToLogin, goToLogout } = useGoTo()

  return <Footer login={isLogin} goToLogin={goToLogin} goToLogout={goToLogout} />
}

export default FooterSection
